export default "__VITE_ASSET__DMoIttVP__"